/*
 * File: colors.ts
 * Project: papa-bear
 * -----
 * Last Modified: 21 Dec 2021 1:39:09 pm
 * -----
 * Copyright (c) 2021 Elegant Software Solutions All rights reserved.
 */

export const toRgb = (color: number[]): string => `rgb(${color.join(',')})`;

export const toRgba = (color: number[], alpha: number): string => `rgb(${color.join(',')}, ${alpha})`;

export const colors = {
  black: [0, 0, 0],
  culturedWhite: [240, 242, 245], // #f0f2f5
  royalBlueLight: [88, 103, 221], // #5867dd
  robinEggBlue: [39, 134, 250], // #2786fa
  raisinBlackLight: [31, 30, 46], // #1f1e2e
  raisinBlackDark: [24, 24, 35], // #181823
  romanSilver: [132, 133, 154], // #84859a
  illuminatingEmerald: [78, 147, 122], // #4e937a
  orangeWeb: [255, 165, 0], // #ffa500
  redSalsa: [249, 57, 67], // #f93943
  minimumYellow: [245, 247, 73] // #f5f749
};
